export function encodeQueryData(data) {
    return Object.keys(data).filter(key => typeof data[key] !== 'undefined').map(
        key => [key, data[key]].map(encodeURIComponent).join('=')
    ).join('&')
}

export function getURL(url, parameters) {
    return `${url}?${encodeQueryData(parameters)}`
}